import * as Yup from 'yup'
import { emailSchema } from './email.validation'
import { passwordSchema } from './password.validation'

const signUpSchema = (withoutAccount: boolean) =>
  Yup.object().shape({
    email: emailSchema.required('validation-required'),
    password: passwordSchema,
    account_holder: Yup.string().when('buisness', {
      is: true,
      then: withoutAccount
        ? Yup.string()
        : Yup.string()
            .required('validation-required')
            .min(1, 'validation-required')
            .max(100, 'validation-max-100'),
      otherwise: Yup.string(),
    }),
    account_website: Yup.string(),
    agreement: Yup.boolean().oneOf([true], 'validaiton-terms-required'),
  })

export { signUpSchema }
